import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m8.283 7 5.45-5.451A.906.906 0 1 0 12.452.266L7 5.718 1.549.266A.906.906 0 1 0 .266 1.549L5.717 7l-5.45 5.452a.906.906 0 1 0 1.282 1.282l5.45-5.451 5.452 5.451a.905.905 0 0 0 1.283 0 .906.906 0 0 0 0-1.282z" }, null, -1)
  ]))]))
}
export default { render: render }